"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const SelectorsHub_1 = __importDefault(require("./SelectorsHub"));
const useSelectorsHub = ({ name, questionnaire, properties, variables, sessionId, answersSheetId, debounceEdit, disabled, }) => {
    return (0, react_1.useMemo)(() => new SelectorsHub_1.default({
        name,
        questionnaire,
        properties,
        variables,
        sessionId,
        answersSheetId,
        debounceEdit,
        disabled,
    }), [
        name,
        questionnaire,
        properties,
        variables,
        sessionId,
        answersSheetId,
        debounceEdit,
        disabled,
    ]);
};
exports.default = useSelectorsHub;
//# sourceMappingURL=useSelectorsHub.js.map